var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthority(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 96,
    viewBox: "0 0 90 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_5532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6972 21.8101V36.4184H51.4798V21.8101C51.4798 17.5694 49.7573 13.7308 46.9768 10.9502C44.1962 8.16959 40.3575 6.4471 36.1169 6.4471C27.6357 6.4471 20.7539 13.3288 20.7539 21.8101V36.4184H14.5366V21.8101C14.5366 9.89207 24.1989 0.229736 36.1169 0.229736C42.08 0.229736 47.4689 2.64942 51.3732 6.55373C55.2857 10.458 57.6972 15.8552 57.6972 21.8101Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0902 31.2427H2.717C1.44859 31.2427 0.420349 32.2709 0.420349 33.5393V82.4334C0.420349 83.7018 1.44859 84.73 2.717 84.73H69.0902C70.3586 84.73 71.3869 83.7018 71.3869 82.4334V33.5393C71.3869 32.2709 70.3586 31.2427 69.0902 31.2427Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1531 54.1762C41.1531 51.2808 38.8072 48.9268 35.9036 48.9268C33 48.9268 30.6541 51.2726 30.6541 54.1762C30.6541 56.0218 31.6056 57.6376 33.041 58.5727L30.892 67.0457H40.907L38.758 58.5727C40.1934 57.6376 41.1449 56.0218 41.1449 54.1762H41.1531Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9719 72.6807V62.6001C51.9719 60.5331 53.3171 58.704 55.2939 58.0888L69.4839 53.6513C70.4025 53.3643 71.3868 53.3643 72.3055 53.6513L86.4955 58.0888C88.4723 58.704 89.8174 60.5331 89.8174 62.6001V72.6807C89.8174 82.5399 83.6985 91.3656 74.4709 94.827L71.7313 95.8523C71.1982 96.0492 70.6076 96.0492 70.0744 95.8523L67.3267 94.827C58.0991 91.3656 51.9801 82.5399 51.9801 72.6807H51.9719Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8783 65.9958V76.3472",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8783 83.4341H70.9029",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_5532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.6186,
    height: 96,
    fill: "white",
    transform: "translate(0.190674)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthority);
export default __webpack_public_path__ + "static/media/authority.6fc254c05a3d307990fe2729ecb6e3c5.svg";
export { ForwardRef as ReactComponent };